var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 214,
    viewBox: "0 0 321 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_10017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H320.5V213.333H0.5V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.963 71.1731C199.521 53.4127 152.49 30.4904 115.334 58.9861C98.0535 72.2398 103.417 81.7512 93.4675 100.528C87.5368 111.72 77.0312 122.391 77.7335 135.24C78.3368 146.331 84.1402 156.362 91.9909 161.392C109.647 172.703 137.621 174.623 152.246 141.235C166.87 107.847 218.991 116.98 204.963 71.1731Z",
    fill: "url(#paint0_linear_386_10017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.912 114.555C234.374 106.82 222.87 108.562 205.441 115.086C192.334 119.995 180.333 124.291 168.842 135.234C160.798 142.89 155.202 151.831 151.567 160.033C147.627 168.919 141.63 179.462 147.885 186.664C156.479 196.556 191.114 197.547 218.053 173.532C247.645 147.146 249.284 122.113 241.912 114.555Z",
    fill: "url(#paint1_linear_386_10017)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.656 99.8776C117.456 99.8776 104.322 86.7434 104.322 70.5443C104.322 54.3448 117.456 41.2109 133.656 41.2109C149.855 41.2109 162.989 54.3448 162.989 70.5443C162.989 86.7434 149.855 99.8776 133.656 99.8776ZM133.656 177.389C117.456 177.389 104.322 164.334 104.322 148.233C104.322 132.132 117.456 119.078 133.656 119.078C149.855 119.078 162.989 132.132 162.989 148.233C162.989 164.334 149.855 177.389 133.656 177.389ZM216.5 99.8776C200.301 99.8776 187.167 86.7434 187.167 70.5443C187.167 54.3448 200.301 41.2109 216.5 41.2109C232.7 41.2109 245.833 54.3448 245.833 70.5443C245.833 86.7434 232.7 99.8776 216.5 99.8776Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.278 66.1001L214.058 78.5445L206.722 71.0789",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.056 66.1001L131.836 78.5445L124.5 71.0789",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.056 143L131.836 155.444L124.5 147.979",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.008 110.752L172.008 110.751C170.598 106.253 175.199 102.223 179.478 104.218L233.948 129.652C233.948 129.652 233.948 129.652 233.948 129.652C238.664 131.856 237.869 138.797 232.78 139.877L210.357 144.622L209.261 144.854L208.886 145.909L200.568 169.316C200.567 169.317 200.567 169.317 200.567 169.317C200.567 169.317 200.567 169.317 200.567 169.317C198.815 174.237 191.832 174.1 190.273 169.13L172.008 110.752Z",
    stroke: "#012A38",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.994 161.522C67.3026 167.943 79.0996 166.589 79.0996 166.589C79.0996 166.589 80.6608 154.824 74.3462 148.408C68.0375 141.987 56.2462 143.336 56.2462 143.336C56.2462 143.336 54.6854 155.101 60.994 161.522Z",
    fill: "url(#paint2_linear_386_10017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.12 34.2305C211.141 37.641 202.743 34.1882 202.743 34.1882C202.743 34.1882 204.044 25.2076 210.027 21.8014C216.006 18.3909 224.4 21.8394 224.4 21.8394C224.4 21.8394 223.099 30.82 217.12 34.2305Z",
    fill: "url(#paint3_linear_386_10017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.885 47.567C103.74 53.8216 92.2483 52.5028 92.2483 52.5028C92.2483 52.5028 90.7275 41.0432 96.8787 34.7926C103.024 28.5376 114.51 29.8525 114.51 29.8525C114.51 29.8525 116.03 41.3124 109.885 47.567Z",
    fill: "url(#paint4_linear_386_10017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6334 105.922C69.5789 105.922 71.9667 108.39 71.9667 111.433C71.9667 114.477 69.5789 116.944 66.6334 116.944C63.6879 116.944 61.3 114.477 61.3 111.433C61.3 108.39 63.6879 105.922 66.6334 105.922Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.322 160.889C230.322 157.379 227.477 154.534 223.967 154.534C220.457 154.534 217.611 157.379 217.611 160.889C217.611 164.399 220.457 167.245 223.967 167.245C227.477 167.245 230.322 164.399 230.322 160.889Z",
    stroke: "#012A38",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6778 85.6886C91.0342 85.6886 92.9445 83.7784 92.9445 81.4219C92.9445 79.0655 91.0342 77.1553 88.6778 77.1553C86.3214 77.1553 84.4111 79.0655 84.4111 81.4219C84.4111 83.7784 86.3214 85.6886 88.6778 85.6886Z",
    fill: "#FF3300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.256 115.166C110.176 115.166 109.3 114.291 109.3 113.211C109.3 112.131 110.176 111.255 111.256 111.255C112.336 111.255 113.211 112.131 113.211 113.211C113.211 114.291 112.336 115.166 111.256 115.166Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.1 133.689C261.536 133.689 264.322 130.983 264.322 127.645C264.322 124.306 261.536 121.6 258.1 121.6C254.663 121.6 251.878 124.306 251.878 127.645C251.878 130.983 254.663 133.689 258.1 133.689Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.833 181.689C176.092 181.689 177.922 179.858 177.922 177.6C177.922 175.342 176.092 173.511 173.833 173.511C171.575 173.511 169.744 175.342 169.744 177.6C169.744 179.858 171.575 181.689 173.833 181.689Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9 39.0777C143.98 39.0777 144.855 38.1226 144.855 36.9444C144.855 35.7662 143.98 34.811 142.9 34.811C141.82 34.811 140.944 35.7662 140.944 36.9444C140.944 38.1226 141.82 39.0777 142.9 39.0777Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.811 101.833C234.811 102.914 235.766 103.789 236.945 103.789C238.123 103.789 239.078 102.914 239.078 101.833C239.078 100.753 238.123 99.8779 236.945 99.8779C235.766 99.8779 234.811 100.753 234.811 101.833Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.878 75.3445C252.86 75.3445 253.656 74.6282 253.656 73.7445C253.656 72.8609 252.86 72.1445 251.878 72.1445C250.896 72.1445 250.1 72.8609 250.1 73.7445C250.1 74.6282 250.896 75.3445 251.878 75.3445Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6999 93.4778C76.78 93.4778 77.6555 92.7615 77.6555 91.8778C77.6555 90.9942 76.78 90.2778 75.6999 90.2778C74.6199 90.2778 73.7444 90.9942 73.7444 91.8778C73.7444 92.7615 74.6199 93.4778 75.6999 93.4778Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.788 40.408C184.21 42.5624 185.489 44.7768 187.643 45.354C189.798 45.9313 192.012 44.6528 192.589 42.4985C193.167 40.3441 191.888 38.1297 189.734 37.5524C187.579 36.9752 185.365 38.2537 184.788 40.408Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8389 59.3777H82.7849C82.4635 63.6049 79.0779 63.6699 79.0779 63.6699C79.0779 63.6699 82.8112 63.7375 82.8112 68.6221C82.8112 63.7375 86.5445 63.6699 86.5445 63.6699C86.5445 63.6699 83.1604 63.6049 82.8389 59.3777ZM250.145 44.4443H250.057C249.537 52.0859 244.056 52.2036 244.056 52.2036C244.056 52.2036 250.1 52.3259 250.1 61.1554C250.1 52.3259 256.145 52.2036 256.145 52.2036C256.145 52.2036 250.665 52.0859 250.145 44.4443Z",
    fill: "#EFEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_386_10017",
    x1: 125.991,
    y1: -18.2833,
    x2: 167.68,
    y2: 292.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_386_10017",
    x1: 191.754,
    y1: 64.777,
    x2: 201.029,
    y2: 281.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_386_10017",
    x1: 86.1645,
    y1: 183.455,
    x2: 40.5563,
    y2: 111.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_386_10017",
    x1: 194.033,
    y1: 45.1258,
    x2: 242.478,
    y2: 2.02114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_386_10017",
    x1: 85.3665,
    y1: 68.9316,
    x2: 129.793,
    y2: -0.711782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_10017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 213.333,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome1);
export default __webpack_public_path__ + "static/media/welcome1.ee9bccf7a28f407db88a96cf7a40ce9e.svg";
export { ForwardRef as ReactComponent };